module.exports = __webpack_public_path__ + "static/media/back_icon.00c5f330.svg";